import { CommApiInstance } from "Utils/CommApiInstance";


const MembLvdRegApi = async (
) => {
    return await CommApiInstance.post(`memb/lvd/reg`,{
        apiBody: {
        }
    })
    .then((Resp) => Resp.data);
}

export default MembLvdRegApi;